import React, { Component } from 'react';
import logo from './assets/GAINZ.png';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to the Gainz web!</h1>
        </header>
        <p className="App-intro">
          This is the Gainz portal app ... coming soon!
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js